import { DatePicker, InputAdornment, TextField } from '@deere/fuel-react';
import { CalendarMonth } from '@mui/icons-material';
import { PropTypes } from 'prop-types';
import React from 'react';
import { INTERVAL } from '../constants';

export const DateInput = ({
    value,
    setValue,
    minDate,
    maxDate,
    dayRestriction,
    weekInMonthOptions = INTERVAL.EVERY_WEEK,
    enableTime,
    error,
    helperText,
    disabled,
}) => {
    const isDateEnabled = (date) => {
        if (dayRestriction == null) return true;
        const isDayOfWeek = date.getDay() === dayRestriction;
        const isWeekOne = date.getDate() < 8;
        const isWeekTwo = date.getDate() >= 8 && date.getDate() < 15;
        const isWeekThree = date.getDate() >= 15 && date.getDate() < 22;
        const isWeekFour = date.getDate() >= 22 && date.getDate() < 29;

        switch (weekInMonthOptions) {
            case INTERVAL.EVERY_WEEK:
                return isDayOfWeek;
            case INTERVAL.FIRST_AND_THIRD_WEEK:
                return (isWeekOne || isWeekThree) && isDayOfWeek;
            case INTERVAL.SECOND_AND_FOURTH_WEEK:
                return (isWeekTwo || isWeekFour) && isDayOfWeek;
            default:
                return isDayOfWeek;
        }
    };

    if (disabled) {
        return <TextField readOnly value={undefined} />;
    }
    return (
        <DatePicker
            disabled={disabled}
            value={value}
            minDate={minDate}
            maxDate={maxDate}
            enableTime={enableTime}
            onChange={(dates) => setValue(dates[0] || minDate)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <CalendarMonth />
                    </InputAdornment>
                ),
                error: error,
                disabled,
                helperText: helperText,
            }}
            flatpickrOptions={{
                defaultDate: value,
                enable: [isDateEnabled],
                enableTime: false,
            }}
        />
    );
};

DateInput.propTypes = {
    minDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
    ]),
    maxDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
    ]),
    dayRestriction: PropTypes.number,
    weekInMonthOptions: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    enableTime: PropTypes.bool,
    setValue: PropTypes.func,
    helperText: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
};
